/* ============================================================
   THE BLACK BUILDING BLOCK — Theme JS
   Scroll observer, parallax, hero init, mobile nav
   ============================================================ */

function initTheme() {
  'use strict';

  // ── Reset banner on page load ──────────────────────────────
  const banner = document.querySelector('.countdown-banner');
  if (banner) {
    banner.style.display = 'block';
    document.body.style.paddingTop = '100px';
    const header = document.querySelector('.site-header');
    if (header) {
      header.style.top = '30px';
    }
  }

  // ── Banner close handler ──────────────────────────────────
  const bannerClose = document.querySelector('.countdown-banner__close');
  if (bannerClose) {
    bannerClose.addEventListener('click', function() {
      const banner = document.querySelector('.countdown-banner');
      const header = document.querySelector('.site-header');
      if (banner) {
        banner.style.display = 'none';
        document.body.style.paddingTop = '0px';
        if (header) {
          header.style.top = '0px';
        }
      }
    });
  }

  // ── Mobile nav toggle ──────────────────────────────────────
  const navToggle = document.querySelector('.nav-toggle');
  const nav       = document.querySelector('.site-header__nav');

  if (navToggle && nav) {
    navToggle.addEventListener('click', function() {
      const open = navToggle.classList.toggle('is-open');
      nav.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });

    // Close on link click
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navToggle.classList.remove('is-open');
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Fade-in on scroll ──────────────────────────────────────
  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.fade-in').forEach((el) => {
    fadeObserver.observe(el);
  });

  // ── Hero init (triggers CSS transitions) ──────────────────
  const hero = document.querySelector('.hero');
  if (hero) {
    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('is-loaded'), 80);
    });
  }

  // ── Parallax (mood break + hero image) ────────────────────
  const parallaxEls = document.querySelectorAll('[data-parallax]');

  function onScroll() {
    const scrollY = window.scrollY;

    parallaxEls.forEach((el) => {
      const rect       = el.closest('[data-parallax-container]')?.getBoundingClientRect()
                       ?? el.getBoundingClientRect();
      const speed      = parseFloat(el.dataset.parallax) || 0.15;
      const centerY    = rect.top + rect.height / 2 - window.innerHeight / 2;
      const offset     = centerY * speed * -1;
      el.style.transform = `translateY(${offset}px)`;
    });
  }

  if (parallaxEls.length > 0) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Data tracking on CTA clicks ────────────────────────────
  document.querySelectorAll('[data-track]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      window.dataLayer.push({ event: this.dataset.track });
    });
  });

  // ── Early access form ──────────────────────────────────────
  document.querySelectorAll('.early-access-form__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      window.dataLayer.push({ event: 'early_access_signup' });
    });
  });

  // ── Lazy-load images beyond the fold ────────────────────
  const lazyImgs = document.querySelectorAll('img[loading="lazy"]');
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading — nothing needed
  } else {
    // Fallback with IntersectionObserver
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          imgObserver.unobserve(img);
        }
      });
    });
    lazyImgs.forEach((img) => imgObserver.observe(img));
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme);
} else {
  // DOM already loaded, call immediately
  initTheme();
}

// Fallback: ensure it runs even if timing is weird
document.addEventListener('DOMContentLoaded', initTheme);
